<template>
  <b-modal
    ref="modalTrocaResponsavel"
    title="Efetue a troca de responsável"
    no-close-on-backdrop
    @hidden="resetModal"
  >
    <validation-observer ref="validacao">
      <b-row>
        <b-col
          cols="12"
        >
          <departamento-select
            ref="departamentoSelect"
            v-model="form.departamento"
            :label="'Escolha o departamento'"
            :require="true"
            @input="limpaCampos"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <responsavel-select
            ref="responsavelDe"
            v-model="form.responsavelDe"
            :label="'Responsável (De)'"
            :disabled="!form.departamento"
            :departamento="form.departamento ? form.departamento.id : 0"
            :require-usuario="true"
            :filtro-adicional="usuariosAtivosInativos"
            :apenas-ativos="false"
          />
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="12">
          <empresa-multiselect
            v-model="form.empresas"
            :label="'Selecione as empresas (Opcional)'"
            :troca-responsavel="true"
            :disabled="!form.departamento"
            :filtro-adicional="empresasAtivasFiltro"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <responsavel-select
            v-model="form.responsavelPara"
            :label="'Responsável (Para)'"
            :disabled="!form.departamento"
            :departamento="form.departamento ? form.departamento.id : 0"
            :filtro-adicional="usuariosAtivos"
            :require-usuario="true"
          />
        </b-col>
      </b-row>
    </validation-observer>
    <template #modal-footer>
      <b-button
        block
        variant="none"
        size="sm"
        class="btn-primary"
        style="margin-left: 0;"
        @click="alterar"
      >Alterar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import api from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'TrocaResponsavel',
  components: {
    ValidationObserver,
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    ResponsavelSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    EmpresaMultiselect: () => import('@/shared/components/empresa-multiselect/EmpresaMultiselect.vue'),
  },
  data() {
    return {
      form: {
        departamento: null,
        responsavelDe: null,
        empresas: [],
        responsavelPara: null,
      },
      empresasRealizadas: [],
    }
  },
  methods: {
    alterar() {
      const formTroca = { ...this.form }
      this.$refs.validacao.validate()
        .then(success => {
          if (success) {
            this.$swal({
              icon: 'question',
              text: 'Deseja realmente alterar o responsável?',
              showCancelButton: true,
              cancelButtonText: 'Não',
              confirmButtonText: 'Sim',
              customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger ml-50',
              },
            })
              .then(result => {
                if (result.value) {
                  api.trocarResponsavel(formTroca)
                    .then(payload => {
                      this.empresasRealizadas = payload.data
                      this.$refs.modalTrocaResponsavel.hide()
                      this.$emit('enviar-pai', this.empresasRealizadas)
                    })
                }
              })
          }
        })
    },
    resetModal() {
      this.form = {
        departamento: null,
        responsavelDe: null,
        empresas: [],
        responsavelPara: null,
      }
    },
    empresasAtivasFiltro(itensCarregados) {
      const empresasFiltradas = []
      for (let index = 0; index < itensCarregados.length; index += 1) {
        const empresa = itensCarregados[index]
        const resposanvel = empresa.responsaveisDepartamento.find(f => f.departamentoId === this.form.departamento.id && f.usuarioId === this.form.responsavelDe.id)
        if (resposanvel) {
          empresasFiltradas.push(empresa)
        }
      }
      const empresasAtivas = empresasFiltradas.filter(fil => fil.ativo)
      return empresasAtivas
    },
    usuariosAtivos(usuarios) {
      if (this.form.responsavelDe) {
        return usuarios.filter(fil => fil.ativo && fil.id !== this.form.responsavelDe.id)
      }

      return usuarios.filter(fil => fil.ativo)
    },
    usuariosAtivosInativos(usuarios) {
      if (this.form.responsavelPara) {
        return usuarios.filter(fil => fil.ativo && fil.id !== this.form.responsavelPara.id)
      }

      return usuarios
    },
    limpaCampos() {
      this.form.responsavelDe = null
      this.form.empresas = []
      this.form.responsavelPara = null
    },
  },
}
</script>
